<template>
  <div class="w-full flex small-page-preview flex-row gap-4">
    <div v-for="(item, index) in itemsList" :key="`item-${index}`" class="w-1/2">
      <mini-pagepreview :rendering="item.fields" />
    </div>
  </div>
</template>

<script>
import MiniPagePreview from './MiniPagePreview.vue';
export default {
  name: 'SmallPagePreview',
  props: {
    rendering: {
      type: Object,
      required: true,
    },
  },
  components: {
    'mini-pagepreview': MiniPagePreview,
  },
  computed: {
    fields() {
      // rendering.fields are populated from route YAML (disconnected)
      // or from Layout Service (integrated)
      return this.rendering?.fields || {};
    },
    itemsList() {
      // Handle both disconnected (array) and connected (value.value array) modes
      const items = this.fields?.items;
      if (!items) return [];

      // If items has a 'value' property, it's from Layout Service (connected mode)
      if (items.value && Array.isArray(items.value)) {
        return items.value;
      }

      // Otherwise it's disconnected mode (direct array)
      if (Array.isArray(items)) {
        // In disconnected mode, wrap each item to match connected structure
        return items.map((item) => ({ fields: item }));
      }

      return [];
    },
  },
};
</script>
<style scoped>
    .banner-gradient {
        background: linear-gradient(149deg,rgba(64, 104, 169, 1) 0%, rgba(0, 54, 140, 1) 22%, rgba(1, 17, 47, 0.4) 80%);
        background-repeat: no-repeat;
        background-size: cover;
    }

.title {
  text-shadow:
    0 0 8px rgba(1, 17, 47, 0.5),
    0 0 16px #01112f;
}
</style>
